<template>
    <div class="container mt-5">
        <Calendar :events="eventsData" :title="calTitle" @cancel="showSpaCancel"></Calendar>
        <b-modal ref="spa-cancel" hide-footer hide-header>
            <div class="d-flex justify-content-end">
                <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hideSpaCancel"></b-icon>
            </div>
            <div class="center column">
                <div class="orange bold">請確認您取消的資訊及時間正確無誤</div>
                <div class="bold mt-4">
                    {{ selectedDate + selectedItem }}
                </div>
                <button type="button" class="btn btn-danger mt-4 w-100" @click="showConfirmCancel">確定取消</button>
                <button type="button" class="btn btn-light mt-3 w-100" @click="hideSpaCancel"
                    style="border: 1px solid black;">返回行事曆</button>
            </div>
        </b-modal>
        <b-modal ref="confirm-cancel" hide-footer hide-header>
            <div class="d-flex justify-content-end">
                <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer"
                    @click="hideConfirmCancel"></b-icon>
            </div>
            <div class="center column">
                <div class="red bold">您已取消</div>
                <div class="bold mt-4">
                    {{ selectedDate + selectedItem }}
                </div>
                <button type="button" class="orange-btn mt-4 w-25 p-2" @click="confirmCancel">確定</button>
            </div>
        </b-modal>
        <div class="footer-stack"></div>
    </div>
</template>

<script>
import Calendar from '@/components/Mymodule/Calendar';

export default {
    data() {
        return {
            calTitle: '克麗緹娜SPA-預約紀錄',
            eventsData: [
                { start: '2025-03-10', end: '2025-03-10', time: '13:00~15:00', title: '光療美甲' },
                { start: '2025-03-10', end: '2025-03-10', time: '15:00~18:00', title: '經典揉霜調理' }
            ],
            selectedDate: '',
            selectedItem: ''
        };
    },
    methods: {
        showSpaCancel({ date, item }) {
            this.selectedDate = date;
            this.selectedItem = item;
            this.$refs['spa-cancel'].show();
        },

        hideSpaCancel() {
            this.$refs['spa-cancel'].hide();
        },

        showConfirmCancel() {
            this.$refs['confirm-cancel'].show();
            this.hideSpaCancel();
        },
        hideConfirmCancel() {
            this.$refs['confirm-cancel'].hide();
        },

        confirmCancel() {
            console.log(`取消預約: ${this.selectedItem}`);
            this.hideConfirmCancel();
        },
    },
    components: {
        Calendar
    }
};
</script>


// WEBPACK FOOTER //
// src/components/View/Spa/SpaRecord.vue